// extracted by mini-css-extract-plugin
export var coming = "ComingSoon-module--coming--dwv52";
export var wrapper = "ComingSoon-module--wrapper--gT6rk";